import { render, staticRenderFns } from "./SearchWrapper.vue?vue&type=template&id=9d9a7a82&"
import script from "./SearchWrapper.vue?vue&type=script&lang=ts&"
export * from "./SearchWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports